var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2l5zFrEIIbvjUm{background-color:hsla(0,0%,100%,.3);height:32px;width:32px;border-radius:3px}._3VsyoVNVJRrGAK{width:80px;height:16px;margin:7px 0;position:relative;opacity:.5;background-image:url(" + escape(require("resources/images/header-logo-spirit-loading.gif")) + ");background-repeat:no-repeat;background-size:contain}._3VsyoVNVJRrGAK :hover{opacity:.8}", ""]);

// exports
exports.locals = {
	"buttonSkeleton": "_2l5zFrEIIbvjUm",
	"newLogo": "_3VsyoVNVJRrGAK"
};